(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('EjemplarDetailsController', EjemplarDetailsController);

    /* @ngInject */
    function EjemplarDetailsController($stateParams, RutasService, ejemplar) {
        var vm = this;

        vm.ejemplar = ejemplar;

        vm.urlBaseTranscrito = RutasService.getEjemplarTranscritoUrl($stateParams.ejemplarId);
        vm.urlBaseDigitalizado = RutasService.getEjemplarDigitalizadoUrl($stateParams.ejemplarId);

        // Gallery
        vm.paginas = [];
        if(vm.ejemplar.paginas!= null){
            vm.ejemplar.paginas.forEach(function (pagina) {
                if (pagina.path) {
                    vm.paginas.push({
                        id: pagina.id,
                        url: 'upload/ejemplares/' + vm.ejemplar.id + '/pagsDigitalizadas' + '/' + pagina.path,
                        thumbUrl: 'upload/ejemplares/' + vm.ejemplar.id + '/pagsDigitalizadas' + '/n_' + pagina.path
                    });
                }
            });
        }

    }

})(angular);
